export interface SkyscannerWidgetDialogResult {
}

export * from './skyscanner-widget-dialog-action.service';
export * from './skyscanner-widget-dialog.module';
